import { render, staticRenderFns } from "./BIMindex.vue?vue&type=template&id=09ab557b&"
import script from "./BIMindex.vue?vue&type=script&lang=js&"
export * from "./BIMindex.vue?vue&type=script&lang=js&"
import style0 from "./BIMindex.vue?vue&type=style&index=0&id=09ab557b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports